// ============================================================================
// JARVISTRAVEL - SKELETON
// A calm placeholder for content that's loading (or not in yet): a soft pulsing
// block in the border tone, so it keeps contrast on both surface and
// surface-raised containers. Prefer this over spinners for in-layout content so
// the page reserves the space and doesn't jump when data arrives. Decorative
// (aria-hidden) — the loading container should carry role="status"/aria-busy.
// Respects reduced motion. Override the fill with a bg-* class when needed.
// ============================================================================

interface SkeletonProps {
  /** Tailwind sizing/shape classes, e.g. "h-4 w-24 rounded-lg". */
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={`block bg-border animate-pulse motion-reduce:animate-none rounded-md ${className}`}
    />
  );
}

export default Skeleton;
